const BUILD_SERIES = {
  pre_A453: 'pre_A453',
  pre_BMW_1ER: 'pre_BMW_1ER',
  pre_BMW_1ER_F40: 'pre_BMW_1ER_F40',
  pre_BMW_2ER_ACTIVE_TOURER: 'pre_BMW_2ER_ACTIVE_TOURER',
  pre_BMW_2ER_CABRIO: 'pre_BMW_2ER_CABRIO',
  pre_BMW_I3: 'pre_BMW_I3',
  pre_BMW_X1: 'pre_BMW_X1',
  pre_BMW_X2: 'pre_BMW_X2',
  pre_C117: 'pre_C117',
  pre_C451: 'pre_C451',
  pre_C453: 'pre_C453',
  pre_C4539: 'pre_C4539',
  pre_FIAT_500: 'pre_FIAT_500',
  pre_FIAT_500_BEV: 'pre_FIAT_500_BEV',
  'pre_MINI_3-TUERER': 'pre_MINI_3-TUERER',
  'pre_MINI_5-TUERER': 'pre_MINI_5-TUERER',
  pre_MINI_CABRIO: 'pre_MINI_CABRIO',
  pre_MINI_CLUBMAN: 'pre_MINI_CLUBMAN',
  pre_MINI_COUNTRYMAN: 'pre_MINI_COUNTRYMAN',
  pre_W177: 'pre_W177',
  pre_W246: 'pre_W246',
  pre_W453: 'pre_W453',
  pre_X156: 'pre_X156',
  pre_W4539: 'pre_W4539',
  pre_FIAT_500_X: 'pre_FIAT_500_X',
  pre_BMW_I3_REX: 'pre_BMW_I3_REX',
  pre_W247: 'pre_W247',
  pre_PEUGEOT_308: 'pre_PEUGEOT_308',
  pre_PEUGEOT_208: 'pre_PEUGEOT_208',
  pre_PEUGEOT_208_EV: 'pre_PEUGEOT_208_EV',
  pre_PEUGEOT_3008: 'pre_PEUGEOT_3008',
  pre_CITROEN_C3: 'pre_CITROEN_C3',
  pre_BMW_X1_HYBRID: 'pre_BMW_X1_HYBRID',
  pre_OPEL_CORSA: 'pre_OPEL_CORSA',
  pre_OPEL_CROSSLAND: 'pre_OPEL_CROSSLAND',
  pre_OPEL_MOKKA: 'pre_OPEL_MOKKA',
  pre_OPEL_ASTRA: 'pre_OPEL_ASTRA'
};

const MBR_BUILD_SERIES = {
  mbr_C253: 'mbr_C253',
  mbr_X247: 'mbr_X247',
  mbr_X253: 'mbr_X253',
  mbr_C118: 'mbr_C118',
  mbr_V177: 'mbr_V177',
  mbr_W177: 'mbr_W177',
  mbr_W247: 'mbr_W247',
  mbr_X118: 'mbr_X118',
  mbr_X157: 'mbr_X157',
  mbr_W213: 'mbr_W213',
  mbr_S213: 'mbr_S213',
};

const CATEGORIES = {
  category_tile_l: 'category_tile_l',
  category_tile_le: 'category_tile_le',
  category_tile_lc: 'category_tile_lc',
  category_tile_m: 'category_tile_m',
  category_tile_me: 'category_tile_me',
  category_tile_mc: 'category_tile_mc',
  category_tile_s: 'category_tile_s',
  category_tile_se: 'category_tile_se',
  category_tile_sc: 'category_tile_sc',
  category_tile_xs: 'category_tile_xs',
  category_tile_xse: 'category_tile_xse',
  category_tile_xsc: 'category_tile_xsc',
  category_title_l: 'category_title_l',
  category_title_le: 'category_title_le',
  category_title_lc: 'category_title_lc',
  category_title_m: 'category_title_m',
  category_title_me: 'category_title_me',
  category_title_mc: 'category_title_mc',
  category_title_s: 'category_title_s',
  category_title_se: 'category_title_se',
  category_title_sc: 'category_title_sc',
  category_title_xs: 'category_title_xs',
  category_title_xl: 'category_title_xl',
  category_title_xse: 'category_title_xse',
  category_title_xsc: 'category_title_xsc',
};

const KNOWN_CITIES = [
  'copenhagen',
  'budapest',
  'frankfurt',
  'amsterdam',
  'berlin',
  'hamburg',
  'milan',
  'munich',
  'paris',
  'rome',
  'turin',
  'vienna',
  'rhineland',
  'stuttgart',
  'ulm',
  'madrid',
];

// generate city_xxx and city_name_xxx_pb keys for all known cities
const CITIES: { [key: string]: string } = {};
KNOWN_CITIES.forEach(city => {
  CITIES[`city_${city}`] = `city_${city}`;
  CITIES[`city_name_${city}_pb`] = `city_name_${city}_pb`;
});

const TRANSLATIONS = {
  cta_register_now: 'cta_register_now',
  footer_personal_freedom_title: 'footer_personal_freedom_title',
  footer_notes_socialMenu_facebook_url: 'footer_notes_socialMenu_facebook_url',
  footer_notes_socialMenu_instagram_url: 'footer_notes_socialMenu_instagram_url',
  footer_notes_socialMenu_twitter_url: 'footer_notes_socialMenu_twitter_url',
  footer_notes_socialMenu_youtube_url: 'footer_notes_socialMenu_youtube_url',
  footer_notes_socialMenu_linkedin_url: 'footer_notes_socialMenu_linkedin_url',
  footer_notes_contact: 'footer_notes_contact',
  footer_notes_careers: 'footer_notes_careers',
  footer_notes_legal_imprint: 'footer_notes_legal_imprint',
  footer_notes_legal_privacy: 'footer_notes_legal_privacy',
  footer_notes_legal_cookies: 'footer_notes_legal_cookies',
  error_page_not_found: 'error_page_not_found',
  cta_back_request: 'cta_back_request',
  headline_success: 'headline_success',
  success_email_confirmation: 'success_email_confirmation',
  success_cancellations_disclaimer_trip: 'success_cancellations_disclaimer_trip',
  success_cta_button: 'success_cta_button',
  success_secondary_cta_restart: 'success_secondary_cta_restart',
  headline_included: 'headline_included',
  benefits_web: 'benefits_web',
  benefits_web_hungary: 'benefits_web_hungary',
  benefits_app: 'benefits_app',
  benefits_app_hungary: 'benefits_app_hungary',
  onboarding_title_first: 'onboarding_title_first',
  onboarding_body_first: 'onboarding_body_first',
  onboarding_body_first_deviate: 'onboarding_body_first_deviate',
  onboarding_title_second: 'onboarding_title_second',
  onboarding_body_second: 'onboarding_body_second',
  headline_included_app: 'headline_included_app',
  onboarding_title_third: 'onboarding_title_third',
  onboarding_body_third: 'onboarding_body_third',
  onboarding_never_again: 'onboarding_never_again',
  cta_onboarding_skip: 'cta_onboarding_skip',
  onboarding_proceed_plan: 'onboarding_proceed_plan',
  onboarding_later: 'onboarding_later',
  headline_extras: 'headline_extras',
  extras_card_included_sub: 'extras_card_included_sub',
  amount_per_day: 'amount_per_day',
  category_allocation_app: 'category_allocation_app',
  ev_excluded: 'ev_excluded',
  prebook_total_description: 'prebook_total_description',
  prebook_for_description: 'prebook_for_description',
  price_flyout_details_app: 'price_flyout_details_app',
  headline_where: 'headline_where',
  field_label_city: 'field_label_city',
  headline_date_time: 'headline_date_time',
  field_label_start_date: 'field_label_start_date',
  field_label_start_time: 'field_label_start_time',
  reservation_period_info: 'reservation_period_info',
  field_label_end_date: 'field_label_end_date',
  field_label_end_time: 'field_label_end_time',
  headline_car_category: 'headline_car_category',
  select_payment_profiles_title: 'select_payment_profiles_title',
  headline_booking_summary: 'headline_booking_summary',
  summary_sub_extras: 'summary_sub_extras',
  return_anywhere_homearea: 'return_anywhere_homearea',
  cta_confirm_booking_button: 'cta_confirm_booking_button',
  cta_continue_button: 'cta_continue_button',
  below_cta_cancellation_deadline: 'below_cta_cancellation_deadline',
  title_estimated_total: 'title_estimated_total',
  summary_included: 'summary_included',
  headline_checkout: 'headline_checkout',
  field_label_first_name: 'field_label_first_name',
  placeholder_first_name: 'placeholder_first_name',
  field_label_last_name: 'field_label_last_name',
  placeholder_last_name: 'placeholder_last_name',
  field_label_mail: 'field_label_mail',
  placeholder_mail: 'placeholder_mail',
  email_subtext: 'email_subtext',
  consent_text: 'consent_text',
  placeholder_address: 'placeholder_address',
  field_label_address_app: 'field_label_address_app',
  field_label_address: 'field_label_address',
  cta_overlay_close: 'cta_overlay_close',
  learn_more_flyout_app: 'learn_more_flyout_app',
  planning_flyout_title_app: 'planning_flyout_title_app',
  planning_flyout_first_subtext: 'planning_flyout_first_subtext',
  planning_flyout_first_subtext_deviate: 'planning_flyout_first_subtext_deviate',
  planning_flyout_second_subtext: 'planning_flyout_second_subtext',
  planning_flyout_third_subtext: 'planning_flyout_third_subtext',
  planning_flyout_third_subtext_deviate: 'planning_flyout_third_subtext_deviate',
  planning_flyout_fourth_subtext: 'planning_flyout_fourth_subtext',
  plan_my_trip: 'plan_my_trip',
  page_title_trip: 'page_title_trip',
  page_title_extras: 'page_title_extras',
  page_title_success: 'page_title_success',
  error_required_field: 'error_required_field',
  api_errors_invalid_address: 'api_errors_invalid_address',
  api_errors_similar_booking: 'api_errors_similar_booking',
  api_errors_generic_error: 'api_errors_generic_error',
  api_errors_nothomearea: 'api_errors_nothomearea',
  error_first_name_mssing: 'error_first_name_mssing',
  error_last_name_missing: 'error_last_name_missing',
  error_email: 'error_email',
  get_app_title: 'get_app_title',
  footer_app_store_url: 'footer_app_store_url',
  footer_playStore_url: 'footer_playStore_url',
  page_title_main: 'page_title_main',
  service_selection_header: 'service_selection_header',
  tile_header_sn: 'tile_header_sn',
  service_selection_collapsed_sn: 'service_selection_collapsed_sn',
  sn_service_selection_one: 'sn_service_selection_one',
  sn_service_selection_two: 'sn_service_selection_two',
  sn_service_selection_three: 'sn_service_selection_three',
  tile_header_mbr: 'tile_header_mbr',
  service_selection_collapsed_mbr: 'service_selection_collapsed_mbr',
  mbr_service_selection_one: 'mbr_service_selection_one',
  mbr_service_selection_two: 'mbr_service_selection_two',
  mbr_service_selection_three: 'mbr_service_selection_three',
  mbr_onboarding_title_first: 'mbr_onboarding_title_first',
  mbr_onboarding_body_first: 'mbr_onboarding_body_first',
  mbr_onboarding_title_second: 'mbr_onboarding_title_second',
  mbr_onboarding_body_second: 'mbr_onboarding_body_second',
  mbr_onboarding_title_third: 'mbr_onboarding_title_third',
  mbr_onboarding_body_third: 'mbr_onboarding_body_third',
  mbr_onboarding_title_fourth: 'mbr_onboarding_title_fourth',
  mbr_onboarding_body_fourth: 'mbr_onboarding_body_fourth',
  mbr_dealership_name: 'mbr_dealership_name',
  mbr_field_label_start_date: 'mbr_field_label_start_date',
  mbr_field_label_start_time: 'mbr_field_label_start_time',
  mbr_field_label_end_date: 'mbr_field_label_end_date',
  mbr_field_label_end_time: 'mbr_field_label_end_time',
  mbr_reservation_period_info: 'mbr_reservation_period_info',
  pick_drop_location_title: 'pick_drop_location_title',
  mbr2_bottom_sheet_headline: 'mbr2_bottom_sheet_headline',
  mbr2_bottom_sheet_intro: 'mbr2_bottom_sheet_intro',
  mbr2_bottom_sheet_condition_one: 'mbr2_bottom_sheet_condition_one',
  mbr2_bottom_sheet_condition_two: 'mbr2_bottom_sheet_condition_two',
  mbr2_bottom_sheet_condition_three: 'mbr2_bottom_sheet_condition_three',
  mbr2_bottom_sheet_condition_four: 'mbr2_bottom_sheet_condition_four',
  mbr2_bottom_sheet_condition_five: 'mbr2_bottom_sheet_condition_five',
  mbr_error_message_one: 'mbr_error_message_one',
  mbr_error_message_two: 'mbr_error_message_two',
  mbr_error_message_three: 'mbr_error_message_three',
  mbr_flyout_deposit_header: 'mbr_flyout_deposit_header',
  mbr_my_reservation: 'mbr_my_reservation',
  mbr_allocate_car: 'mbr_allocate_car',
  mbr_legal_consent: 'mbr_legal_consent',
  mbr_confirm_final: 'mbr_confirm_final',
  mbr_deposit_hold_until: 'mbr_deposit_hold_until',
  mbr_flyout_mileage_header: 'mbr_flyout_mileage_header',
  mbr_flyout_mileage_subtext: 'mbr_flyout_mileage_subtext',
  mbr_benefits: 'mbr_benefits',
  mbr_fuel_specification: 'mbr_fuel_specification',
  mbr_total: 'mbr_total',
  mbr_payment_specification: 'mbr_payment_specification',
  mbr_incl: 'mbr_incl',
  mbr_success_header: 'mbr_success_header',
  mbr_success_subtext: 'mbr_success_subtext',
  mbr_success_adjust_cancel: 'mbr_success_adjust_cancel',
  mbr_cta_done: 'mbr_cta_done',
  mbr_cta_restart: 'mbr_cta_restart',
  mbr_flyout_deposit_subtext: 'mbr_flyout_deposit_subtext',
  category_sold_out: 'category_sold_out',
  headline_not_available: 'headline_not_available',
  category_too_young: 'category_too_young',
  error_no_pricing_offers: 'error_no_pricing_offers',
  error_too_soon_to_prebook: 'error_too_soon_to_prebook',
  error_max_booking_duration_exceeded: 'error_max_booking_duration_exceeded',
  error_prebook_start_too_far_away: 'error_prebook_start_too_far_away',
  additional_driver_title_fd: 'additional_driver_title_fd',
  additional_driver_content_fd: 'additional_driver_content_fd',
  coming_soon: 'coming_soon',
  select_city_header: 'select_city_header',
  mobs_base_fee_hu: 'mobs_base_fee_hu',
  fuel_included_pb: 'fuel_included_pb',
  charge_included_pb: 'charge_included_pb',
  category_card_engine_type_combustion: 'category_card_engine_type_combustion',
  category_card_engine_type_electric: 'category_card_engine_type_electric',
  category_card_seats: 'category_card_seats',
  category_card_automatic: 'category_card_automatic',
  category_card_manual: 'category_card_manual',
  category_card_minimum_age: 'category_card_minimum_age',
  available_cars_cta: 'available_cars_cta',
  booking_pick_up_return: 'booking_pick_up_return',
  book_now_title: 'book_now_title',
  trip_edit: 'trip_edit',
  return_homearea_breadcrumb: 'return_homearea_breadcrumb',
  cta_select_button: 'cta_select_button',
  page_title_category: 'page_title_category',
  calculator_headline_entry: 'calculator_headline_entry',
  calculator_description: 'calculator_description',
  calculator_cta: 'calculator_cta',
  free_parking_pb_title: 'free_parking_pb_title',
  free_parking_pb_body: 'free_parking_pb_body',
  free_fueling_pb_title: 'free_fueling_pb_title',
  free_fueling_pb_body: 'free_fueling_pb_body',
  free_charging_pb_title: 'free_charging_pb_title',
  free_charging_pb_body: 'free_charging_pb_body',
  free_charging_madrid_pb_body: 'free_charging_madrid_pb_body',
  calculator_done: 'calculator_done',
  calculator_edit: 'calculator_edit',
  calculator_learn_more: 'calculator_learn_more',
  price_calculator_cta: 'price_calculator_cta',
  calculator_mileage_title: 'calculator_mileage_title',
  calculator_in_use_body: 'calculator_in_use_body',
  user_mileage_estimation_request: 'user_mileage_estimation_request',
  ad_invitation_title: 'ad_invitation_title',
  ad_invitation_sub: 'ad_invitation_sub',
  ad_cta_copy: 'ad_cta_copy',
  ad_state_copied: 'ad_state_copied',
  ad_invitation_valid_until: 'ad_invitation_valid_until',
  ad_invitation_primary_privacy_disclaimer: 'ad_invitation_primary_privacy_disclaimer',
  ad_invitation_shared_text: 'ad_invitation_shared_text',
  bookable_via_app: 'bookable_via_app',
  category_card_engine_type_hybrid: 'category_card_engine_type_hybrid',
  urgency_title_hours_minutes: 'urgency_title_hours_minutes',
  urgency_title_days_hours: 'urgency_title_days_hours',
  urgency_subtitle: 'urgency_subtitle',
  urgency_profile: 'urgency_profile',
  urgency_payment: 'urgency_payment',
  urgency_drivers_license: 'urgency_drivers_license',
  redirect_in_countdown: 'redirect_in_countdown',
  redirect_cta: 'redirect_cta',
  checkmark_subtitle: 'checkmark_subtitle',
  send_tnc_pb: 'send_tnc_pb',
  tnc_title_header: 'tnc_title_header',
  tnc_sub_details: 'tnc_sub_details',
  payment_select_private_profile: 'payment_select_private_profile',
  payment_select_business_profile: 'payment_select_business_profile',
  payment_select_no_valid_profile: 'payment_select_no_valid_profile',
  payment_select_no_valid_profile_troubleshoot: 'payment_select_no_valid_profile_troubleshoot',
  service_selection_collapsed_f2M_rent: 'service_selection_collapsed_f2M_rent',
  f2m_rent_service_selection_one: 'f2m_rent_service_selection_one',
  f2m_rent_service_selection_two: 'f2m_rent_service_selection_two',
  f2m_rent_service_selection_three: 'f2m_rent_service_selection_three',
  tile_header_f2m_rent: 'tile_header_f2m_rent'
};

export const TRANSLATION_KEYS = { ...TRANSLATIONS, ...BUILD_SERIES, ...CATEGORIES, ...CITIES, ...MBR_BUILD_SERIES };
